module.exports = __webpack_public_path__ + "img/step3.b16a11ce.jpg";